import React from 'react';
import { isBefore } from 'date-fns';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import Text from 'components/Text';
import Row from 'components/Row';
import { Holiday2021Banner } from 'coaching/components/Banners';

export type Props = {
  firstName?: string;
  hasUpcomingSessions: boolean;
};

export default function CoachingHomeWelcomeHeader(props: Props) {
  // This banner is for Christmas & New Years' 2021-2022, so hide it after the 1st
  const shouldShowBanner = isBefore(new Date(), '2022-01-02');
  return (
    <>
      <Row size="xsmall">
        <Heading level="1" serif flush>
          Welcome, {props.firstName}
        </Heading>
      </Row>
      <Row>
        <Text size="medium" color="graphite">
          {props.hasUpcomingSessions
            ? 'Get ready for the upcoming session!'
            : 'Whether your child is tackling a tough assignment or needs extra practice for a test, we’re here to help.'}
        </Text>
      </Row>
      <Row>{shouldShowBanner ? <Holiday2021Banner /> : <Divider size="flush" />}</Row>
    </>
  );
}
